// extracted by mini-css-extract-plugin
module.exports = {"container":"Status_container__1Xv0E","row":"Status_row__3CEhK","col":"Status_col__2Ffln"};